
export enum VisadEntitet {
    Arbetsorder = "Arbetsorder",
    Atgard = "Atgard",
    Virkeskop = "Virkesköp",
    Kundorder = "Kundorder"
}

export enum Dialogtyp {
    Handelselogg = "Händelselogg"
}
